// @flow
import React, { useState } from 'react';
import type { Element } from 'react';
import { withTranslation, Link } from '@i18n';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { GlobalState } from '@globalTypes';
import {
  LocationIcon,
  HotelIcon,
  HospitalIcon,
  CityTourIcon,
} from '@images/svg/index';
import { colors } from '@components/ListItemFacility/styles';
import { PROFILE_PACKAGE_FORM } from '@routes';

import {
  StyledPackages,
  StyledTopImageGridWapper,
  StyledFacilityCards,
  StyledCardItemsWrapper,
  StyledFacilityCardsTextWrapper,
  StyledFacilityCardsTitle,
  StyledFacilityCardsSubtitle,
  StyledDesktopVisible,
  StyledTitleSecond,
  StyledLocationWrapper,
  StyledLocationIconWrapper,
  StyledLocationText,
  StyledTopTextGridWapper,
  StyledFacilityCardsWrapperDesktopVisible,
  StyledPriceWrapper,
  StyledPriceHeadline,
  StyledSaveWrapper,
  StyledAmountContent,
  StyledOldPrice,
  StyledSaveInfoContent,
  StyledPayNow,
  StyledBookButton,
  StyledBookText,
  CarouselControls,
  CarouselControl,
  StyledMobileVisible,
  StyledTitleMain,
  StyledDesktopPackages,
} from './styles';


const DoctorPackages = ({
  t,
  packageFinder
}): Element<any> => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const packages = packageFinder?.data;
  const { length } = packages;
  const onScreenCount = 1;
  const HideArrow = (packages || []).slice(0, 8).length > 1;
  return (
    <StyledDesktopPackages>
      <StyledPackages>
        <StyledMobileVisible>
          <StyledTitleMain>{packages[currentIndex]?.attributes?.name}</StyledTitleMain>
          <StyledLocationWrapper>
            <StyledLocationIconWrapper>
              <LocationIcon />
            </StyledLocationIconWrapper>
            <StyledLocationText>
              {packages[currentIndex]?.attributes?.city}
              ,
              {packages[currentIndex]?.attributes?.country}
            </StyledLocationText>
          </StyledLocationWrapper>
        </StyledMobileVisible>
        <StyledTopImageGridWapper size={{ mobile: 1 / 1, desktop: 1 / 2 }}>
          <>
            {packages[currentIndex]?.attributes?.cover_image_url
                && packages[currentIndex]?.attributes?.cover_image_url ? (
                  <img src={packages[currentIndex]?.attributes?.cover_image_url} alt="" />
                ) : (
                  <img src="/static/images/svg/ProfilePackage/staticPackage.png" alt="" />
                )}
          </>
        </StyledTopImageGridWapper>
        <StyledTopTextGridWapper>
          <StyledDesktopVisible>
            <StyledTitleSecond>{packages[currentIndex]?.attributes?.name}</StyledTitleSecond>
            <StyledLocationWrapper>
              <StyledLocationIconWrapper>
                <LocationIcon />
              </StyledLocationIconWrapper>
              <StyledLocationText>
                {packages[currentIndex]?.attributes?.city}
                ,
                {packages[currentIndex]?.attributes?.country}
              </StyledLocationText>
            </StyledLocationWrapper>
          </StyledDesktopVisible>

          <StyledFacilityCardsWrapperDesktopVisible>
            <StyledFacilityCards size={{ mobile: 1 / 3 }}>
              <StyledCardItemsWrapper>
                <HospitalIcon />
                <StyledFacilityCardsTextWrapper>
                  <StyledFacilityCardsTitle>{t('DaysInHospital')}</StyledFacilityCardsTitle>
                  <StyledFacilityCardsSubtitle>
                    {packages[currentIndex]?.attributes?.days_in_hospital}
                    {t('Days')}
                  </StyledFacilityCardsSubtitle>
                </StyledFacilityCardsTextWrapper>
              </StyledCardItemsWrapper>
            </StyledFacilityCards>

            <StyledFacilityCards size={{ mobile: 1 / 3 }}>
              <StyledCardItemsWrapper>
                <HotelIcon />
                <StyledFacilityCardsTextWrapper>
                  <StyledFacilityCardsTitle>{t('DaysInHotel')}</StyledFacilityCardsTitle>
                  <StyledFacilityCardsSubtitle>
                    {packages[currentIndex]?.attributes?.days_in_hotel}
                    {t('Days')}
                  </StyledFacilityCardsSubtitle>
                </StyledFacilityCardsTextWrapper>
              </StyledCardItemsWrapper>
            </StyledFacilityCards>

            <StyledFacilityCards size={{ mobile: 1 / 3 }}>
              <StyledCardItemsWrapper>
                <img src="/svg/packageScreen/cash.svg" alt="cash-card" />
                <StyledFacilityCardsTextWrapper>
                  <StyledFacilityCardsTitle>{t('CashVoucher')}</StyledFacilityCardsTitle>
                  <StyledFacilityCardsSubtitle>
                    {t('MoneyData', { money: 75 })}
                  </StyledFacilityCardsSubtitle>
                </StyledFacilityCardsTextWrapper>
              </StyledCardItemsWrapper>
            </StyledFacilityCards>

            <StyledFacilityCards size={{ mobile: 1 / 3 }}>
              <StyledCardItemsWrapper>
                <CityTourIcon />
                <StyledFacilityCardsTextWrapper>
                  <StyledFacilityCardsTitle>{t('CityTourTitle')}</StyledFacilityCardsTitle>
                  <StyledFacilityCardsSubtitle>
                    {t('PersonData', { total: 2 })}
                  </StyledFacilityCardsSubtitle>
                </StyledFacilityCardsTextWrapper>
              </StyledCardItemsWrapper>
            </StyledFacilityCards>

            <StyledFacilityCards size={{ mobile: 1 / 3 }}>
              <StyledCardItemsWrapper>
                <img src="/svg/packageScreen/refund.svg" alt="refund" />
                <StyledFacilityCardsTextWrapper>
                  <StyledFacilityCardsTitle>{t('Refund')}</StyledFacilityCardsTitle>
                  <StyledFacilityCardsSubtitle>{t('Cancellation')}</StyledFacilityCardsSubtitle>
                </StyledFacilityCardsTextWrapper>
              </StyledCardItemsWrapper>
            </StyledFacilityCards>

            <StyledFacilityCards size={{ mobile: 1 / 3 }}>
              <StyledCardItemsWrapper>
                <img src="/svg/packageScreen/room-upgrade.svg" alt="room-upgrade" />
                <StyledFacilityCardsTextWrapper>
                  <StyledFacilityCardsTitle>{t('RoomUpgrade')}</StyledFacilityCardsTitle>
                  <StyledFacilityCardsSubtitle color={colors.saveGreen}>
                    {t('Free')}
                  </StyledFacilityCardsSubtitle>
                </StyledFacilityCardsTextWrapper>
              </StyledCardItemsWrapper>
            </StyledFacilityCards>
          </StyledFacilityCardsWrapperDesktopVisible>
          <StyledPriceWrapper>
            <StyledPriceHeadline>{t('CostTitle')}</StyledPriceHeadline>

            <StyledSaveWrapper>
              <StyledAmountContent>
                <StyledOldPrice>
                  $
                  {packages[currentIndex]?.attributes?.original_price}
                </StyledOldPrice>
                <StyledPayNow>
                  $
                  {packages[currentIndex]?.attributes?.selling_price}
                </StyledPayNow>
              </StyledAmountContent>
              <StyledSaveInfoContent>
                {t('SaveInfo', { amount: packages[currentIndex]?.attributes?.saving_amount })}
              </StyledSaveInfoContent>
            </StyledSaveWrapper>
          </StyledPriceWrapper>
          <Link
            href={PROFILE_PACKAGE_FORM}
            params={{ slug: packages[currentIndex]?.attributes?.slug }}
          >
            <StyledBookButton>
              {t('BookNow', {
                amount:
                      ((packages[currentIndex]?.attributes?.selling_price ?? 0)
                        * (packages[currentIndex]?.attributes?.booking_percentage ?? 10))
                      / 100
              })}
            </StyledBookButton>
          </Link>

          <StyledBookText>{t('PayLater')}</StyledBookText>
        </StyledTopTextGridWapper>
      </StyledPackages>
      <CarouselControls HideArrow={HideArrow}>
        <CarouselControl
          hide={currentIndex === 0}
          onClick={() => {
            setCurrentIndex(Math.max(currentIndex - 1, 0));
          }}
          className="carousel-control-prev"
        >
          <img src="/images/svg/moveleftarrow.svg" alt="arrow" />
        </CarouselControl>
        <CarouselControl
          hide={currentIndex + 1 === Math.ceil(length / onScreenCount)}
          onClick={() => {
            setCurrentIndex(Math.min(currentIndex + 1, Math.ceil(length / onScreenCount) - 1));
          }}
          className="carousel-control-next"
        >
          <img src="/images/svg//moverightarrow.svg" alt="arrow" />
        </CarouselControl>
      </CarouselControls>
    </StyledDesktopPackages>
  );
};

const mapStateToProps = (state: GlobalState): {} => ({
  packageFinder: state.packageFinder,
});

const DoctorPackagesScreen = compose(
  connect(
    mapStateToProps,
  ),
  withTranslation('DetailsJob')
)(DoctorPackages);

DoctorPackagesScreen.getInitialProps = async () => ({
  namespacesRequired: ['DetailsJob']
});

export default DoctorPackagesScreen;
